import React from 'react';
import NoNetworkImg from '@jwp/ott-theme/assets/icons/no_network.svg?react';
import Icon from '../Icon/Icon';
import style from './NoNetwork.module.scss';
import Button from '../Button/Button';
import { useTheme } from '../../../../../ThemeContext';

const NoNetwork = () => {
  const { universalStyles } = useTheme();
  return (
    <div className={style.noNetworkContainer}>
      <Icon icon={NoNetworkImg} className={style.icon} />
      <h1>{`No network connection`}</h1>
      <p>{`Please check your internet connection and try again.`}</p>
      <br />
      <Button
        variant="contained"
        color="primary"
        onClick={() => window.location.reload()}
        label={`Retry`}
        aria-haspopup="dialog"
        style={universalStyles.signUpButton}
        textStyle={universalStyles.signUpButtonText}
      />
    </div>
  );
};

export default NoNetwork;
